module.exports = __webpack_public_path__ + "img/ameex-ma.e43fd05c.png";